<template>
  <v-container>
    <v-overlay :value="loadingOverlay" opacity="0.7">
      <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div class="users">
      <v-snackbar top v-model="alert" multi-line :color="alert_mode">
        {{ alert_text }}
        <v-btn text @click="alert = false">{{$t('close')}}</v-btn>
      </v-snackbar>
      <h2 class="mt-5 mb-10">{{$t('employee')}}</h2>
      <v-dialog overlay-opacity="0.7" v-model="dialogSchedule" max-width="700px">
        <v-form v-model="validEdit">
          <v-card class="pt-3">
            <v-card-title>
              <span class="headline ml-2">{{$t('edit_schedule_user')}}</span>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="12" class="pb-0 pt-0">
                  <v-text-field :label="$t('name')" v-model="scheduleItem.full_name" type="text" disabled>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-list-item-content>
                <span class="subtitle-2 font-weight-bold">{{$t('schedule_in')}} :</span>
              </v-list-item-content>
              <v-row>
                <v-col sm="2" md="2" class="pb-0 pt-0">
                  <v-text-field :label="$t('mon')" v-model="scheduleItem.monday_in" type="time" :rules="[rules[0]]">
                  </v-text-field>
                </v-col>
                <v-col sm="2" md="2" class="pb-0 pt-0">
                  <v-text-field :label="$t('tue')" v-model="scheduleItem.tuesday_in" type="time" :rules="[rules[0]]">
                  </v-text-field>
                </v-col>
                <v-col sm="2" md="2" class="pb-0 pt-0">
                  <v-text-field :label="$t('wed')" v-model="scheduleItem.wednesday_in" type="time" :rules="[rules[0]]">
                  </v-text-field>
                </v-col>
                <v-col sm="2" md="2" class="pb-0 pt-0">
                  <v-text-field :label="$t('thu')" v-model="scheduleItem.thursday_in" type="time" :rules="[rules[0]]">
                  </v-text-field>
                </v-col>
                <v-col sm="2" md="2" class="pb-0 pt-0">
                  <v-text-field :label="$t('fri')" v-model="scheduleItem.friday_in" type="time" :rules="[rules[0]]">
                  </v-text-field>
                </v-col>
                <v-col sm="2" md="2" class="pb-0 pt-0"></v-col>
                <v-col sm="2" md="2" class="pb-0 pt-0">
                  <v-text-field :label="$t('sat')" v-model="scheduleItem.saturday_in" type="time" :rules="[rules[0]]">
                  </v-text-field>
                </v-col>
                <v-col sm="2" md="2" class="pb-0 pt-0">
                  <v-text-field :label="$t('sun')" v-model="scheduleItem.sunday_in" type="time" :rules="[rules[0]]">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-list-item-content>
                <span class="subtitle-2 font-weight-bold">{{$t('schedule_out')}} :</span>
              </v-list-item-content>
              <v-row>
                <v-col sm="2" md="2" class="pb-0 pt-0">
                  <v-text-field :label="$t('mon')" v-model="scheduleItem.monday_out" type="time" :rules="[rules[0]]">
                  </v-text-field>
                </v-col>
                <v-col sm="2" md="2" class="pb-0 pt-0">
                  <v-text-field :label="$t('tue')" v-model="scheduleItem.tuesday_out" type="time" :rules="[rules[0]]">
                  </v-text-field>
                </v-col>
                <v-col sm="2" md="2" class="pb-0 pt-0">
                  <v-text-field :label="$t('wed')" v-model="scheduleItem.wednesday_out" type="time" :rules="[rules[0]]">
                  </v-text-field>
                </v-col>
                <v-col sm="2" md="2" class="pb-0 pt-0">
                  <v-text-field :label="$t('thu')" v-model="scheduleItem.thursday_out" type="time" :rules="[rules[0]]">
                  </v-text-field>
                </v-col>
                <v-col sm="2" md="2" class="pb-0 pt-0">
                  <v-text-field :label="$t('fri')" v-model="scheduleItem.friday_out" type="time" :rules="[rules[0]]">
                  </v-text-field>
                </v-col>
                <v-col sm="2" md="2" class="pb-0 pt-0"></v-col>
                <v-col sm="2" md="2" class="pb-0 pt-0">
                  <v-text-field :label="$t('sat')" v-model="scheduleItem.saturday_out" type="time"></v-text-field>
                </v-col>
                <v-col sm="2" md="2" class="pb-0 pt-0">
                  <v-text-field :label="$t('sun')" v-model="scheduleItem.sunday_out" type="time" :rules="[rules[0]]">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-card-actions class="pb-6">
                <v-row justify="center">
                  <v-btn color="primary" text @click="dialogSchedule = false">{{$t('cancel')}}</v-btn>
                  <v-btn color="primary" dark @click="saveSchedule(scheduleItem)">{{$t('save')}}</v-btn>
                </v-row>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog overlay-opacity="0.7" v-model="dialogInformation" max-width="560px">
        <v-card class="pa-6">
          <h2>Active User Information</h2>
          <br>
          <p style="color: #3277D5; font-size: 12px; line-height: 16px;">What’s the difference between Active User and
            Registered User?</p>
          <p style="font-size: 16px; line-height: 21px;">Registered user : User that has been added to the employee page
            Active user : User that has been activated</p>
          <p style="color: #3277D5; font-size: 12px; line-height: 16px;">How to activate a user?</p>
          <p style="font-size: 16px; line-height: 21px;" class="mb-n1">You can activate user by clicking switch button
            on active
            column</p>
          <v-row align="center" justify-center style="margin-left: -30px;">
            <v-col> <img src="img/activate-image.png" style="position: relative;">
              <img src="img/mouseover.png" class="mouseover">
            </v-col>
            <v-col style="margin-left: -100px;"> <img src="img/not-active.png"></v-col>
            <v-col style="margin-left: -50px;"> <img src="img/active.png"></v-col>
          </v-row>
          <p style="color: #3277D5; font-size: 12px; line-height: 16px;">Is there any limit for the amount of Active
            User and Registered User?</p>
          <p style="font-size: 16px; line-height: 21px;" class="mb-n1">Registered user have no limit on quantity, but
            Active User have.</p>
          <v-row align="center" justify-center style="margin-left: -30px;">
            <v-col>
              <img src="img/limit-user.png">
            </v-col>
          </v-row>
          <p style="color: #686868; font-size: 12px; line-height: 16px;" class="mb-n1">Example : You have 16 out of 50
            Active User and 67 Registered User.</p>
          <v-row align="center" justify-center style="margin-left: -30px;">
            <v-col>
              <img src="img/example.png">
            </v-col>
            <v-col>
              You can’t activate user more than its limit
            </v-col>
          </v-row>
          <v-row align="center" justify-center class="mt-n4">
            <v-col>
              <p style="color: #3277D5; font-size: 12px; line-height: 16px;">How to extend the limit amount of Active
                User?</p>
              <p style="font-size: 16px; line-height: 21px;" class="mt-n2">Please update your appsensi plan, click here
              </p>

            </v-col>
            <v-col cols="4">
              <v-btn outlined color="primary" @click="addForm()">Update Plan</v-btn>
            </v-col>

          </v-row>
          <v-row align="center" justify-center class="mt-4">
            <v-col>
              <center>
                <v-btn color="primary" @click="dialogInformation = false">I UNDERSTAND</v-btn>
              </center>
            </v-col>
          </v-row>

        </v-card>
      </v-dialog>
      <v-dialog overlay-opacity="0.7" v-model="dialogTab" min-height="90vh" max-width="1150px" class="form-no-scroll"
        scrollable>
        <v-navigation-drawer width="300" v-model="dialogTab">
          <v-card color="primary" dark class="pl-0 rounded-0">
            <v-card color="primary">
              <v-card-text class="h-90">
                <v-list-item-title class="f-16 mt-3 ml-3 mb-3 white--text">{{$t('employee_details')}}
                </v-list-item-title>
                <v-tabs class="f-14" vertical v-model="tab" background-color="primary">
                  <v-tab ripple class="pl-0 f-13 text-left primary" router v-for="(item,i) in menuDialog"
                    :key="`sae-${i}`" :name="item.name">
                    <v-list-item>
                      <v-list-item-icon class="mr-2">
                        <img :src="item.icon ? item.icon : transparent" alt width="18" height="18" />
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title v-text="item.name" class="f-13 capitalize"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-tab>
                </v-tabs>
              </v-card-text>
            </v-card>
          </v-card>
        </v-navigation-drawer>
        <div class="pa-0 form-scroll">
          <v-card class="pa-0 rounded-0">
            <v-card-text class="h-90">
              <v-layout row class="pl-6 pr-6 pt-5 pb-2">
                <v-flex>
                  <v-autocomplete v-model="searchForm" :items="dataSearch" :loading="loadingSearch"
                    :search-input.sync="searchInput" hide-no-data hide-selected item-text="full_name" item-value="id"
                    :label="$t('search_employee')" prepend-icon="mdi-magnify" return-object @change="selectedUserChange"
                    clearable></v-autocomplete>
                </v-flex>
                <v-flex md2 class="pa-0">
                  <div class="float-right pr-3">
                    <v-progress-circular v-if="loadingOverlay" color="primary" indeterminate size="56">
                    </v-progress-circular>
                    <v-avatar v-if="!loadingOverlay" size="56" class="ma-1 sae-img-border" floati>
                      <img
                        :src="selectedUserDetail.avatar_url != null? selectedUserDetail.avatar_url : 'img/logo_initial_gradient.png'"
                        alt="Avatar" onerror="this.onerror=null;this.src='img/logo_initial_gradient.png'" />
                    </v-avatar>
                    
                  </div>
                </v-flex>
                <v-flex shrink>
                  <div class="mw-250">
                    <div :class="addMargin(selectedUserDetail.full_name)"
                      class="d-flex flex-column">
                      <p class="bold f-13 break-word capitalize mb-1">
                        {{selectedUserDetail.full_name}}
                      </p>

                      <div class="d-flex">
                        <div
                          style="border-radius: 20px; font-size: 10px; font-weight: 500; padding: 2px 12px;"
                          :style="selectedUserDetail.status ? 'background-color: rgba(113, 203, 79, 0.1); color: #71CB4F;' : 'background-color: rgba(230, 74, 77, 0.1); color: #E64A4D;'"
                        >
                          <p class="mb-0">
                            {{ selectedUserDetail.status ? 'Active' : 'Inactive' }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-flex>
              </v-layout>

              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <employee-information v-if="tab == 0" v-bind:userId="selectedUserId"
                    v-bind:employeeInformation="dataPersonalDetail.employeeInformation"
                    v-bind:groupListSelection="groupListSelection" v-bind:payrollEnabled="gcPayrollEnabled"
                    @reload="selectedUserChange(selectedUserDetail, true)" />
                </v-tab-item>
                <v-tab-item>
                  <address-list v-if="tab == 1" v-bind:userId="selectedUserId"
                    v-bind:addressList="dataPersonalDetail.addresses"
                    @reload="selectedUserChange(selectedUserDetail, true)" />
                </v-tab-item>
                <v-tab-item>
                  <grade-personal v-if="tab == 2" v-bind:userId="selectedUserId"
                    v-bind:addressList="dataPersonalDetail.addresses"
                    @reload="selectedUserChange(selectedUserDetail, true)" />
                </v-tab-item>
                <v-tab-item>
                  <education-list v-if="tab == 3" v-bind:userId="selectedUserId"
                    v-bind:educationList="dataPersonalDetail.educations"
                    @reload="selectedUserChange(selectedUserDetail, true)" />
                </v-tab-item>
                <v-tab-item>
                  <family-list v-if="tab == 4" v-bind:userId="selectedUserId"
                    v-bind:familyList="dataPersonalDetail.families"
                    @reload="selectedUserChange(selectedUserDetail, true)" />
                </v-tab-item>
                <v-tab-item>
                  <emergency-contact-list v-if="tab == 5" v-bind:userId="selectedUserId"
                    v-bind:contactList="dataPersonalDetail.emergencyContacts"
                    @reload="selectedUserChange(selectedUserDetail, true)" />
                </v-tab-item>
                <v-tab-item>
                  <medical-checkup-list v-if="tab == 6" v-bind:userId="selectedUserId"
                    v-bind:medical="dataPersonalDetail.medicalCheckup"
                    @reload="selectedUserChange(selectedUserDetail, true)" />
                </v-tab-item>
                <v-tab-item>
                  <working-experience v-if="tab == 7" v-bind:userId="selectedUserId"
                    v-bind:workingExperienceList="dataPersonalDetail.workExperiences"
                    @reload="selectedUserChange(selectedUserDetail, true)" />
                </v-tab-item>
                <v-tab-item>
                  <bank-account v-if="tab == 8" v-bind:userId="selectedUserId"
                    v-bind:bankAccount="dataPersonalDetail.bankAccount"
                    @reload="selectedUserChange(selectedUserDetail, true)" />
                </v-tab-item>
                <v-tab-item >
                  <folder v-if="tab == 9" v-bind:userId="selectedUserId"
                    v-bind:bankAccount="dataPersonalDetail.folder"
                    @reload="selectedUserChange(selectedUserDetail, true)" />
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>
        </div>
      </v-dialog>

      <v-card class="px-6 pb-0 mb-4" style="height: 71px;">
        <v-row>
          <v-col md="3" class="mt-n3">
            <v-text-field hide-details :label="$t('find_user')" prepend-inner-icon="mdi-magnify" single-line
              v-model="search.keyword" @keyup.enter="fetchUsers()"></v-text-field>
          </v-col>
          <v-col md="2" class="mt-n3">
            <v-select :items="roles" :placeholder="$t('access_type')" v-model="search.role" item-text="name"
              item-value="id" @change="fetchUsers()"></v-select>
          </v-col>
          <v-col md="2" class="mt-n4">
            <v-autocomplete
              :items="groupList"
              item-text="alias"
              item-value="id"
              :label="$t('search_group')"
              v-model="search.groups"
              @change="fetchUsers()"
            ></v-autocomplete>
          </v-col>
          <v-col md="3" class="mt-2">
            <download-excel :data="users_report" worksheet="Data Employee" :name="title">
              <v-btn block outlined color="primary" :loading="loadingDownload">
                <v-icon>mdi-download</v-icon>{{$t('download_report')}}
              </v-btn>
            </download-excel>
          </v-col>
          <v-col md="2" class="mt-2">
            <v-btn 
              v-if="billingInfo.latest_billing"
              color="primary"
              class="mb-2"
              @click="checkOverQuota()"
              block
            >
            {{$t('add_user')}}
            </v-btn>
            <v-btn v-else color="primary" class="mb-2" v-on="on" @click="addedItem()" block>{{$t('add_user')}}</v-btn>
            <v-dialog overlay-opacity="0.7" v-model="addDialog" max-width="1000px">
              <employee-information v-if="addDialog" v-bind:groupListSelection="groupListSelection"
                v-bind:payrollEnabled="gcPayrollEnabled" @close="refreshData" />
            </v-dialog>
          </v-col>
        </v-row>
      </v-card>
      <v-row style="height: 71px;" class="mb-8" align="center" justify="center">
        <v-col :md="billingInfo.latest_billing ? checkUserLength('left') : '12'" :xl="billingInfo.latest_billing ? '7' : '12'" style="height: 71px;">
          <v-card class="px-6 pb-0 mt-4 mb-4" style="height: 71px;">
            <v-row>
              <v-col class="pt-0">
                <v-select v-model="status" :items="[
              { name: 'All Status', id: null },
              { name: 'Active', id: 1 },
              { name: 'Inactive', id: 0 },
            ]" label="User Status" item-text="name" item-value="id" @change="showActiveUsers($event)">
                </v-select>
              </v-col>
              <v-col class="pt-0">
                <v-select :items="[
              { name: $t('all'), id: null },
              { name: $t('shifting'), id: true },
              { name: $t('regular'), id: false },
            ]" :label="$t('user_type')" item-text="name" item-value="id" @change="showShiftingUsers($event)">
                </v-select>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col v-if="billingInfo.latest_billing" :md="checkUserLength('right')" xl="5" style="height: 100%">
          <v-row>
            <v-col cols="10">
              <v-card class="px-6 pb-0 mt-4 mb-4" style="height: 71px;">
                <v-row align="center" justify="center" style="height: 100%;">
                  <v-col class="text-center">
                    <span style="color: #686868; font-size: 16px;">Active User :</span>
                    <span style="color: #3277D5; font-size: 16px;"> <b> 
                      <span :style="billingInfo.latest_billing.activeUser > billingInfo.latest_billing.total_paid_user ? 'color: #E64A4D;' : 'color: #3277D5;'">
                        {{billingInfo.latest_billing.activeUser}}
                      </span>
                      / {{billingInfo.latest_billing.total_paid_user}}
                      </b></span>
                      <br>
                      <span v-if="billingInfo.latest_billing.activeUser > billingInfo.latest_billing.total_paid_user" style="color: #E64A4D;">
                        Overquota !
                      </span>
                  </v-col>
                  <v-col class="text-center">
                    <span style="color: #686868; font-size: 16px;">Registered User:</span> <span
                      style="color: #040404; font-size: 16px;"><b>
                        {{billingInfo.totalUser}} 
                        </b></span>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="2">
              <v-card class="px-6 pb-0 mt-4 mb-4" style="height: 71px;" @click="dialogInformation = true">
                <v-row align="center" justify="center" style="height: 100%;">
                  <v-col align="center" justify-center>
                    <center>
                      <img src="img/information.png">
                    </center>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>

        <v-col cols="12" sm="12" md="12">
          <v-data-table v-if="!firstLoading" :loading="loading" :headers="headers" :items="users" class="elevation-1"
            :server-items-length="totalData" :items-per-page="itemPerPage"
            :footer-props="{ 'items-per-page-options': [10, 50, 100, 500], 'items-per-page-text': $t('rows_per_page')  }"
            :page="page" disable-sort @update:page="fetchUsers($event, itemPerPage)"
            @update:items-per-page="fetchUsers(page, $event)" @current-items="filteredUser"
            :no-data-text="$t('no_data')">
            <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}}
              {{ items.itemsLength }} </template>
            <template v-slot:top>
              <v-dialog overlay-opacity="0.7" v-model="dialog" max-width="500px">
                <v-form v-model="validEdit">
                  <v-card class="pt-3">
                    <v-card-title>
                      <span class="headline ml-2">{{ formTitle }}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field class="sae-required" :label="$t('full_name')" v-model="editedItem.full_name"
                              :rules="nameRules"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field :label="$t('email')" v-model="editedItem.email" :rules="emailRules"
                              class="sae-required" required></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field :label="$t('job_position')" v-model="editedItem.job_position"></v-text-field>
                          </v-col>
                          <v-col class="d-flex" cols="12" sm="6">
                            <v-autocomplete v-model="editedItem.groupId" :items="groupListSelection" hide-no-data
                              hide-selected item-text="alias" item-value="id" :label="$t('group')" required
                              :rules="rules2" class="sae-required"></v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field label="Income" v-model="editedItem.income" type="number"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field class="sae-required" :label="$t('employee_id')"
                              v-model="editedItem.employee_code" :rules="rules"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-select :items="role" class="sae-required" :label="$t('access_type')"
                              v-model="editedItem.role" item-text="name" item-value="id" @change="changeUserRole"
                              :rules="rules2"></v-select>
                          </v-col>
                          <v-col class="d-flex" cols="12" md="6" sm="12">
                            <v-switch :label="`Active`" inset class="my-0 py-0" v-model="editedItem.status"
                              color="rgb(0,150,45)" @change="changeNUserStatus"></v-switch>
                          </v-col>
                          <v-col cols="12" sm="6" md="6" v-show="userAbility.length > 0">
                            <v-alert outlined>
                              <!-- <p class="overline mb-2">Mobile Only</p> -->
                              <div class="caption">{{ userAbility }}</div>
                            </v-alert>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-alert outlined>
                              <p class="overline mb-2">{{ nUserStatus.active }}</p>
                              <p class="caption">{{ nUserStatus.message }}</p>
                            </v-alert>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions class="mx-6 pb-6">
                      <v-row justify="center">
                        <v-btn color="primary" text @click="close">{{$t('cancel')}}</v-btn>
                        <v-btn color="primary" :disabled="!validEdit" @click="saveToAPI(editedItem)">{{$t('save')}}
                        </v-btn>
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </v-dialog>
              <!-- 
              ### DELETE DIALOG 
              -->
              <v-dialog overlay-opacity="0.7" v-model="deleteDialog" max-width="290">
                <v-card>
                  <v-card-title class="headline">{{$t('delete_user')}}</v-card-title>
                  <v-card-text>{{$t('you_sure')}}</v-card-text>
                  <v-card-actions class="pa-3">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="deleteDialog = false">{{$t('cancel')}}</v-btn>
                    <v-btn color="error" :loading="loading" @click="deleteUser(itemToDelete)">{{$t('delete')}}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
            <template v-slot:item.action="{ item }">
              <v-row align="center">
                <v-btn icon @click="editSchedule(item)" color="primary" v-if="!item.is_shifted" small class="mr-2">
                  <v-icon small>mdi-calendar</v-icon>
                </v-btn>
                <v-btn color="primary accent-3" @click="selectedUserChange(item)" icon small>
                  <v-icon small>mdi-card-account-details-outline</v-icon>
                </v-btn>
                <div v-if="check_role != 0">
                  <div v-if="item.role == 2 || item.role == 0">
                    <v-btn icon v-show="false" small color="error" @click="deleteItem(item)">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                  <div v-else>
                    <v-btn icon small color="error" @click="deleteItem(item)">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </div>
                <div v-else-if="check_role == 0 && (company_id === 'demo-appsensi' || company_id === 'pemkab-raja-ampat')">
                  <div v-if="item.role == 2 || item.role == 0">
                    <v-btn icon v-show="false" small color="error" @click="deleteItem(item)">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                  <div v-else>
                    <v-btn icon small color="error" @click="deleteItem(item)">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                  </div>
              </v-row>
            </template>
            <template v-slot:item.register_user="{ item }">
              <div class="d-flex flex-column align-center">
                <div v-if="item.id.length == 28">
                  <v-icon small color="success">mdi-check-circle-outline</v-icon>
                </div>
                <div v-else>
                  <v-icon small color="error">mdi-close-circle-outline</v-icon>
                </div>
 
                <p v-if="$store.getters.gcGetData('feature_contract_duration', 'is_enabled')" class="text-center"
                :class="item.duration_end ? (defineDaysLeft(item.duration_end) === '0 Day Left' ? 'text-danger' : 'text-blue') : ''">
                  {{
                    item.duration_end ? (defineDaysLeft(item.duration_end)) : (item.created_at
                      ? defineWorkDuration(item.created_at)
                      : "No duration")
                  }}
                </p>
              </div>
            </template>
            <template v-slot:item.status="{ item }">
              <v-switch inset color="success" @change="putStatus(item.id, item.status)" v-model="item.status">
              </v-switch>
            </template>
            <template v-slot:item.role="{ item }">
              <div v-if="item.role == 0">Admin HRD</div>
              <div v-else-if="item.role == 1">Staff</div>
              <div v-else-if="item.role == 2">Admin Appsensi</div>
              <div v-else-if="item.role == 3">Supervisor</div>
              <div v-else-if="item.role == 4">Executive</div>
            </template>
            <template v-slot:item.full_name="{ item }">
              <div v-if="item.full_name">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <b @click="openDetailsDialog(item)" v-bind="attrs" v-on="on"
                      class="cursor text-primary">{{ item.full_name }}</b>
                  </template>
                  <span>{{$t('click_schedule')}}</span>
                </v-tooltip>
              </div>
              <div v-if="!item.full_name">-</div>
            </template>

          </v-data-table>

        </v-col>
        <v-card v-if="activateUserDialog" style="position:fixed;
            width: 560px;
            height: 80px;
            bottom: 50px;
            left: 50%;
            margin-left: -160px;">
          <v-row class="pa-0 ma-0 px-3" align="center" justify="center" style="height: 100%">
            <v-col md="7">
              <span style="color: #040404; font-size: 20px;">Active user changes :</span> <span
                style="color: #3277D5; font-size: 20px;">{{userActivationId.length}}</span>
            </v-col>
            <v-col md="5">
              <v-row>
                <v-col md="6">
                  <v-btn @click="submitActivation(false)" color="white"
                    style="border-radius: 2px; padding: 10px 20px 10px 20px; width: 94px;">Cancel</v-btn>
                </v-col>
                <v-col md="6">
                  <v-btn @click="submitActivation(true)" color="primary"
                    style="border-radius: 2px; padding: 10px 20px 10px 20px;  width: 94px;">Save</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-row>

      <!-- Skeleton Loader -->
      <v-skeleton-loader class="mx-auto" type="table-tbody" v-if="loading && firstLoading"></v-skeleton-loader>
      <v-dialog overlay-opacity="0.7" v-model="detailsDialog" max-width="900px">
        <v-card class="pt-3" v-if="!loadingDetails">
          <v-container>
            <v-card-title>
              <v-icon medium class="mr-2" color="primary">mdi-account</v-icon>
              {{ user_detail.full_name }}
            </v-card-title>
            <v-card-subtitle class="pb-0">
              <v-icon medium class="mr-2" color="primary">mdi-email</v-icon>
              {{ user_detail.email }}
            </v-card-subtitle>
            <v-card-text class="pb-0">
              <v-icon medium class="mr-2" color="primary">mdi-briefcase</v-icon>
              {{ user_detail.job_position }}
            </v-card-text>
            <v-card-text class="pt-1">
              <v-icon medium class="mr-2" color="primary">mdi-account-group-outline</v-icon>
              {{ user_full_detail.group.alias }}
            </v-card-text>
            <v-card-text>
              <span class="title text--primary">{{$t('schedule')}}</span>
              <div v-if="detailSchedule && !user_full_detail.is_shifted">
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-card height="200px" style="padding: 25px; height: 100%">
                      <v-row justify="space-between">
                        <v-col md="1" class="text-center">
                          <b class="text-center">{{$t('mon')}}</b>
                          {{ shortenTime(detailSchedule.monday_in) }}
                        </v-col>
                        <v-col md="1" class="text-center">
                          <b class="text-center">{{$t('tue')}}</b>
                          {{ shortenTime(detailSchedule.tuesday_in) }}
                        </v-col>
                        <v-col md="1" class="text-center">
                          <b class="text-center">{{$t('wed')}}</b>
                          {{ shortenTime(detailSchedule.wednesday_in) }}
                        </v-col>
                        <v-col md="1" class="text-center">
                          <b class="text-center">{{$t('thu')}}</b>
                          {{ shortenTime(detailSchedule.thursday_in) }}
                        </v-col>
                        <v-col md="1" class="text-center">
                          <b class="text-center">{{$t('fri')}}</b>
                          {{ shortenTime(detailSchedule.friday_in) }}
                        </v-col>
                        <v-col md="1" class="text-center">
                          <b class="text-center">{{$t('sat')}}</b>
                          {{ shortenTime(detailSchedule.saturday_in) }}
                        </v-col>
                        <v-col md="1" class="text-center">
                          <b class="text-center">{{$t('sun')}}</b>
                          {{ shortenTime(detailSchedule.sunday_in) }}
                        </v-col>
                      </v-row>
                      <v-row justify="space-between">
                        <v-col md="1" class="text-center">
                          {{
                          shortenTime(detailSchedule.monday_out)
                          }}
                        </v-col>
                        <v-col md="1" class="text-center">
                          {{
                          shortenTime(detailSchedule.tuesday_out)
                          }}
                        </v-col>
                        <v-col md="1" class="text-center">
                          {{
                          shortenTime(detailSchedule.wednesday_out)
                          }}
                        </v-col>
                        <v-col md="1" class="text-center">
                          {{
                          shortenTime(detailSchedule.thursday_out)
                          }}
                        </v-col>
                        <v-col md="1" class="text-center">
                          {{
                          shortenTime(detailSchedule.friday_out)
                          }}
                        </v-col>
                        <v-col md="1" class="text-center">
                          {{
                          shortenTime(detailSchedule.saturday_out)
                          }}
                        </v-col>
                        <v-col md="1" class="text-center">
                          {{
                          shortenTime(detailSchedule.sunday_out)
                          }}
                        </v-col>
                      </v-row>
                      <!-- <v-card-actions class="mt-2">
                        <v-btn text color="primary">View</v-btn>
                        <v-btn text color="primary">Edit</v-btn>
                      </v-card-actions>-->
                    </v-card>
                  </v-col>
                </v-row>
              </div>
              <div v-else>
                <p v-if="user_full_detail.is_shifted">{{$t('for_shifting')}}</p>
                <p v-else>{{$t('no_schedule')}}</p>
              </div>
              <v-divider class="my-6"></v-divider>
              <span class="title text--primary">{{$t('zones')}}</span>
              <v-row>
                <v-col cols="12" sm="12" md="12" v-for="(item,i) in detailZone" v-bind:key="i">
                  <v-card max-height="200px">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-title class="title mb-1">{{ item.zonename }}</v-list-item-title>
                        <v-list-item-subtitle class="my-2">
                          <v-icon x-small color="red">mdi-map-marker</v-icon>
                          {{ item.lat_zone + ", " + item.lng_zone }}
                        </v-list-item-subtitle>
                        <p>{{ item.address_zone }}</p>
                      </v-list-item-content>
                    </v-list-item>
                    <v-card-actions>
                      <!-- <v-btn text color="primary">View</v-btn> -->
                      <!-- <v-btn text color="primary">Edit</v-btn> -->
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-container>
        </v-card>
        <v-card class="pa-6" v-if="loadingDetails">
          <v-card-title>
            <span class="headline">{{$t('user_details')}}</span>
          </v-card-title>
          <v-row>
            <v-skeleton-loader class="mx-auto" type="table-tbody"></v-skeleton-loader>
          </v-row>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>
<script>
  import moment from "moment";
  import EmployeeInformation from './Employee/components/EmployeeInformation'
  import AddressList from './Employee/components/AddressList'
  import EducationList from './Employee/components/EducationList'
  import FamilyList from './Employee/components/FamilyList'
  import EmergencyContactList from './Employee/components/EmergencyContact'
  import MedicalCheckupList from './Employee/components/MedicalCheckupList'
  import WorkingExperience from './Employee/components/WorkingExperience'
  import BankAccount from './Employee/components/BankAccount'
  import GradePersonal from './Employee/components/GradePersonal.vue'
  import Folder from './Employee/components/Folder.vue'

  export default {
    name: "users",
    components: {
      EmployeeInformation,
      AddressList,
      EducationList,
      FamilyList,
      EmergencyContactList,
      MedicalCheckupList,
      WorkingExperience,
      BankAccount,
      GradePersonal,
      Folder
    },
    data() {
      return {
        transparent: 'img/menu_icon/transparent.png',
        menuDialog: [{
            id: 0,
            name: this.$i18n.t('general_information'),
            icon: 'img/menu_dialog/employee_information.png'
          },
          {
            id: 1,
            name: this.$i18n.t('address'),
            icon: 'img/menu_dialog/address.png'
          },
          {
            id: 8,
            name: this.$i18n.t('grade_history'),
            icon: 'img/menu_dialog/grade.png'
          },
          {
            id: 2,
            name: this.$i18n.t('education'),
            icon: 'img/menu_dialog/education.png'
          },
          {
            id: 3,
            name: this.$i18n.t('family'),
            icon: 'img/menu_dialog/family.png'
          },
          {
            id: 4,
            name: this.$i18n.t('emergency_contact'),
            icon: 'img/menu_dialog/emergency_contact.png'
          },
          {
            id: 5,
            name: this.$i18n.t('medical_information'),
            icon: 'img/menu_dialog/medical_record.png'
          },
          {
            id: 6,
            name: this.$i18n.t('work_experience'),
            icon: 'img/menu_dialog/work_experience.png'
          },
          {
            id: 7,
            name: this.$i18n.t('bank_account'),
            icon: 'img/menu_dialog/bank_details.png'
          },
          {
            id: 8,
            name: 'Folder',
            icon: 'img/menu_dialog/folder.png'
          }
        ],
        dialogInformation: false,
        dataPersonalDetail: {},
        loadingOverlay: false,
        selectedUserId: null,
        selectedUserDetail: {},
        tab: null,
        dialogTab: false,
        loadingDownload: false,
        saveLoading: false,
        loadingSearch: false,
        dataSearch: [],
        check_role: this.$store.state.role,
        title: `Data Employee - ${this.$store.state.companyName
        } - ${moment().locale(this.$i18n.t('lang')).format("DD-MM-YYYY HHmm")}`,
        search: {
          keyword: "",
          role: ""
        },
        searchForm: '',
        searchInput: '',
        baseUrl: this.$store.state.baseUrl,
        alert_text: "",
        alert_mode: "",
        alert: false,
        dialogSchedule: false,
        status: null,
        scheduleItem: {
          monday_in: "",
          monday_out: "",
          tuesday_in: "",
          tuesday_out: "",
          wednesday_in: "",
          wednesday_out: "",
          thursday_in: "",
          thursday_out: "",
          friday_in: "",
          friday_out: "",
          saturday_in: "",
          saturday_out: "",
          sunday_in: "",
          sunday_out: "",
          user_id: "",
        },
        user_full_detail: {
          group: {
            alias: ""
          }
        },
        disableSort: true,
        firstLoading: true,
        page: 1,
        itemPerPage: 10,
        totalData: 0,
        userAbility: "",
        nUserStatus: {
          active: "",
          message: "",
        },
        users: [{
          id: "",
          email: "",
          full_name: "",
        }, ],
        addItem: {
          id: "",
          email: "",
          full_name: "-",
          role: "",
          groupId: "",
          income: "",
          job_position: "",
        },
        loading: true,
        headers: [
          // { text: "ID", value: "id" },
          {
            text: this.$i18n.t('employee_id'),
            value: "employee_code",
            width: "10%"
          },
          {
            text: this.$i18n.t('full_name'),
            value: "full_name",
            width: "20%"
          },
          {
            text: this.$i18n.t('email'),
            value: "email",
            width: "18%"
          },
          {
            text: this.$i18n.t('job_position'),
            value: "job_position"
          },
          {
            text: this.$i18n.t('access_type'),
            value: "role"
          },
          {
            text: this.$i18n.t('activation'),
            value: "register_user"
          },
          {
            text: this.$i18n.t('active'),
            value: "status"
          },
          {
            text: this.$i18n.t('manage'),
            value: "action"
          },
        ],
        editedItem: {
          id: "",
          email: "",
          full_name: "",
          groupId: "",
          role: "",
          income: "",
          job_position: "",
          status: null,
        },
        itemToDelete: {
          id: "",
          full_name: "",
          companyId: "",
          is_registered: '',
        },
        radios: "",
        tempUsers: [],
        users_report: [],
        usersReportFiltered: [],
        usersLength: 0,
        showUsersActiveOnly: false,
        showUsersShiftingOnly: null,
        groupList: [],
        groupListSelection: [],
        editedIndex: -1,
        dialog: false,
        scheduleHeaders: [this.$i18n.t('mon'), this.$i18n.t('tue'), this.$i18n.t('wed'), this.$i18n.t('thu'), this.$i18n
          .t('fri'), this.$i18n.t('sat'), this.$i18n.t('sun')
        ],
        loadingDetails: false,
        detailsDialog: false,
        detailsItem: {},
        detailSchedule: {},
        detailZone: [],
        user_detail: [],
        userActivationId: [],
        userActivationStatus: [],
        addDialog: false,
        company_id: this.$store.state.company,
        total_users: this.$store.state.user.detail.companyInfo,
        // total_users: this.$store.state.user.detail.companyInfo,
        // billingInfo: {},
        deleteDialog: false,
        activateUserDialog: false,
        role: [{
            name: "Admin HRD",
            id: 0,
          },
          {
            name: "Staff",
            id: 1,
          },
          // {
          //   name: "Admin Appsensi",
          //   id: 2
          // },
          {
            name: "Supervisor",
            id: 3,
          },
          {
            name: "Executive",
            id: 4,
          },
        ],
        religionList: [],
        genderList: [],
        roles: [{
          name: this.$i18n.t('all'),
          id: "-"
        }],
        rules: [(value) => (value === 0 ? true : !!value || this.$i18n.t('required'))],
        rules2: [(value) => (value == 0 ? true : value ? value > 0 : !!value || this.$i18n.t('required'))],
        validAdd: true,
        validEdit: true,
        emailRules: [
          (v) => !!v || this.$i18n.t('required'),
          (v) => /.+@.+\..+/.test(v) || this.$i18n.t('email_required'),
        ],
        nameRules: [
          (v) => !!v || this.$i18n.t('required'),
          (v) => (v && v.length <= 50) || "Name must be less than 50 characters",
        ],
        checkbox: true,
        disableInput: true,
      };
    },
    computed: {
      gcFolderEnabled() {
        return this.$store.getters.gcGetData('feature_employee_folder', 'is_enabled')
      },
      gcPayrollEnabled() {
        return this.$store.getters.gcGetData('feature_payroll', 'is_enabled')
      },
      formTitle() {
        return this.editedIndex === -1 ? this.$i18n.t('new_item') : this.$i18n.t('edit_user');
      },
      billingInfo() {
        return this.$store.getters.getBillingInfo
      }
    },
    created() {
      this.getReligion()
      this.getGender()
    },
    methods: {
      async getGender() {
      this.loading = true
      this.genderList = await this.$store.dispatch('getGender')
      this.loading = false
    },
      defineDaysLeft(days_left){
        const start_date = moment(new Date(days_left));
        const today = moment();

        const diff = moment.duration(start_date.diff(today));

        const years = diff.years();
        const months = diff.months();
        const days = diff.days();
        const ms = diff.milliseconds();

        const year =
          years > 0
            ? years > 1
              ? `${years} Years`
              : `${years} Year`
            : "";

        const month =
          months > 0
            ? months > 1
              ? `${months} Months`
              : `${months} Month`
            : "";

        const day =
          year === ""
            ? days > 0
              ? days > 1
                ? `${days} Days`
                : `${days} Day`
              : ""
            : "";

        if (year === "" && month === "" && day === "") {
          if (ms > 0) {
            return 'Less than 1 day left';
          }
          return `0 Day Left`;
        }

        return `${year} ${month} ${day} Left`;
      },
      defineWorkDuration(work_duration) {
        const start_date = moment(work_duration);
        const today = moment();

        const diff = moment.duration(today.diff(start_date));

        const years = diff.years();
        const months = diff.months();
        const days = diff.days();

        const year =
          years > 0
            ? years > 1
              ? `${years} Years`
              : `${years} Year`
            : "";

        const month =
          months > 0
            ? months > 1
              ? `${months} Months`
              : `${months} Month`
            : "";

        const day =
          year === ""
            ? days > 0
              ? days > 1
                ? `${days} Days`
                : `${days} Day`
              : ""
            : "";

        if (year === "" && month === "" && day === "") {
          return `1 Day`;
        }

        return `${year} ${month} ${day}`;

      },
      checkUserLength(position) {
        if(
          this.billingInfo.latest_billing.activeUser > 9999 ||
          this.billingInfo.latest_billing.total_paid_user > 9999 ||
          this.billingInfo.totalUser > 9999
        ) {
          if (position === 'left') {
            return 5
          } else {
            return 7
          }
        } else {
          if (position === 'left') {
            return 6
          } else {
            return 6
          }
        }
      },
      addForm() {
        window.open(
          `https://docs.google.com/forms/d/e/1FAIpQLSdNg9-Gxmi6IQZ9yYXMtTcQvFLFb1I4cxg90VpDhLu4oSmyHA/viewform`
        );
      },
      putStatus(id, status) {
        this.activateUserDialog = true
        if (this.userActivationId.includes(id)) {
          const index = this.userActivationId.indexOf(id)
          this.userActivationStatus[index] = status
        } else {
          this.userActivationId.push(id)
          this.userActivationStatus.push(status)
        }
      },
      async submitActivation(payload) {
        if (payload) {
          this.loading = true
          const newUsers = await this.$store.dispatch('updateEmployeeActive', {
            companyId: this.company_id,
            userId: this.userActivationId,
            status: this.userActivationStatus
          })
          const newTotal = await this.$store.dispatch('getGlobalConfig', {
            userId: this.$store.state.user.id
          })
          this.total_users = newTotal.companyInfo
          this.activateUserDialog = false
          this.userActivationId = []
          this.userActivationStatus = []
          this.fetchUsers();
        if(newUsers){
          this.showMessage('success', 'Data saved successfuly')
        }
        } else {
          this.activateUserDialog = false
          this.userActivationId = []
          this.userActivationStatus = []
          this.fetchUsers();
        }

      },
      addMargin(name = '') {
        return name.length <= 34 ? 'mt-4' : 'mt-2'
      },
      changeTab(tab) {
        this.tab = tab
      },
      async selectedUserChange(item, reload = false) {
        if (item != null) {
          this.selectedUserId = item.id
          this.selectedUserDetail = item
          this.loadingOverlay = true
          if (!reload) {
            this.tab = 0
          } else {
            this.fetchUsers()
          }
          const result = await this.$store.dispatch('getEmployeePersonalDetail', {
            userId: this.selectedUserId
          })
          this.loadingOverlay = false
          this.dataPersonalDetail = result
          this.dialogTab = true
        }
      },
      changeRules(data) {
        if (data == true) {
          this.disableInput = true;
        } else {
          this.disableInput = false;
        }
      },
      getRole(role) {
        switch (role) {
          case 0:
            return "Admin HRD";
          case 1:
            return "Staff";
          case 3:
            return "Supervisor";
          case 4:
            return "Executive";
        }
      },
      changeNUserStatus(status) {
        if (status) {
          this.nUserStatus.active = "Active User";
          this.nUserStatus.message = "Means this user can access a certain page";
        } else {
          this.nUserStatus.active = "Inactive User";
          this.nUserStatus.message = "This user has no more access";
        }
      },
      changeUserRole(role) {
        switch (role) {
          case 0:
            this.userAbility =
              this.$i18n.t('ability_0');
            break;
          case 1:
            this.userAbility =
              this.$i18n.t('ability_1');
            break;
          case 3:
            this.userAbility =
              this.$i18n.t('ability_2');
            break;
          case 4:
            this.userAbility =
              this.$i18n.t('ability_3');
            break;
        }
      },
      showActiveUsers(data) {
        this.showUsersActiveOnly = data;
        this.fetchUsers(this.page, this.itemPerPage, data);
      },
      showShiftingUsers(data) {
        this.showUsersShiftingOnly = data;
        this.fetchUsers(this.page, this.itemPerPage, data);
      },
      filteredUser(data) {
        if (this.usersLength != data.length) {
          this.usersLength = data.length;
          this.usersReportFiltered = [];
          data.map((row) => {
            const user = {
              EmployeeCode: row.employee_code,
              Name: row.full_name,
              Email: row.email,
              Position: row.job_position,
              Level: row.level,
              Register: this.statusRegister(row.is_registered),
            };
            this.usersReportFiltered.push(user);
          });
        }
      },
      shortenTime(time) {
        return moment(time, "HH:mm:ss").format("HH:mm");
      },
      formatTime(date) {
        return moment(date).locale(this.$i18n.t('lang')).format("Do MMMM YYYY, HH:mm");
      },
      openDetailsDialog(item) {
        this.loadingDetails = true;
        this.detailsItem = this.users.indexOf(item);
        this.detailsItem = Object.assign({}, item);
        this.user_detail = item;
        // this.detailsDialog = true;
        this.fetchUserDetails(item.id);
      },
      editItem(item) {
        this.editedIndex = this.users.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
        this.disableInput = true;
        this.checkbox = true;
        this.fetchGroupDetails();
      },
      editSchedule(item) {
        this.scheduleItem = Object.assign({}, item);
        this.fetchUserDetails(item.id, "schedule");
      },
      addedItem() {
        this.fetchGroupDetails();
        this.addDialog = true;
      },
      deleteItem(item) {
        this.itemToDelete = Object.assign({}, item);
        this.deleteDialog = true;
      },
      statusRegister(registered = null) {
        if (registered == true) {
          return "Registered";
        } else {
          return "Unregistered";
        }
      },
      statusRegisterAlternative(userId = '') {
        if (userId.length == 28) {
          return "Registered";
        } else {
          return "Unregistered";
        }
      },
      close() {
        this.dialog = false;
        this.addDialog = false;
      },
      checkOverQuota() {
        this.billingInfo.latest_billing.activeUser >= this.billingInfo.latest_billing.total_paid_user ? this.$store.dispatch('toggleOverQuotaModal', true) : this.addedItem()
      },
      async saveSchedule(item) {
        const data = {
          monday_in: item.monday_in,
          monday_out: item.monday_out,
          tuesday_in: item.tuesday_in,
          tuesday_out: item.tuesday_out,
          wednesday_in: item.wednesday_in,
          wednesday_out: item.wednesday_out,
          thursday_in: item.thursday_in,
          thursday_out: item.thursday_out,
          friday_in: item.friday_in,
          friday_out: item.friday_out,
          saturday_in: item.saturday_in,
          saturday_out: item.saturday_out,
          sunday_in: item.sunday_in,
          sunday_out: item.sunday_out,
          user_id: item.userId,
        }
        const result = await this.$store.dispatch('saveScheduleUser', data)
        if (result) {
          this.showMessage('success', 'Data saved successfuly')
          this.dialogSchedule = false
          this.fetchUsers()
        }
      },
      showMessage(type, msg) {
        this.$store.dispatch('nShowMessage', {
          type,
          msg
        })
      },
      async updateScheduleUserWhenGroupChange(userId, groupId) {
        const scheduleGroup = await this.$store.dispatch('getScheduleGroup', {
          groupId
        })
        const body = Object.assign({}, scheduleGroup)
        body.user_id = userId
        const result = await this.$store.dispatch('saveScheduleUser', body)
        if (result) {
          this.showMessage("success", "Data save successfuly");
          this.dialog = false;
          this.fetchUsers();
        }
      },
      async saveToAPI(item) {
        let param = {
          id: item.id,
          full_name: item.full_name,
          job_position: item.job_position,
          groupId: item.groupId,
          status: item.status,
          income: item.income ? item.income : 0,
          role: item.role,
          employee_code: item.employee_code,
          email: this.editedItem.email
        };
        const result = await this.$store.dispatch('editEmployeeData', param)
        if (result) {
          this.updateScheduleUserWhenGroupChange(item.id, item.groupId);
        }
      },
      async fetchUsers(page = 1, itemPerPage = 10) {
        this.page = page;
        this.itemPerPage = itemPerPage;
        const totalPageSend = itemPerPage < 1 ? this.totalData : itemPerPage;
        const start = this.page;

        let param = {
          companyId: this.company_id,
          page: start,
          pageSize: totalPageSend
        }
        if (this.search.keyword.length > 0) param.keyword = this.search.keyword
        if (
          this.search.role.toString() != "" &&
          this.search.role.toString() != "-"
        ) param.role = this.search.role
        if (this.status != null) param.status = this.status
        if (this.search.groups) param.groupId = this.search.groups
        if (this.showUsersShiftingOnly != null) param.isShifted = this.showUsersShiftingOnly

        this.loading = true;
        const result = await this.$store.dispatch('getEmployeeByKeyword', param)
        this.totalData = result.total;
        this.users = result.records;
        this.loading = false;
        if (this.firstLoading) {
          this.fetchUsersDownload();
        }
      },
      mappingDataReport(data) {
        this.users_report = [];
        data.forEach((row) => {
          if (row.role != 2) {
            let reportUser = {};
            reportUser["Employee Code"] = row.employee_code;
            reportUser["Full Name"] = row.full_name;
            reportUser["KTP"] = row.ktp_number ? `'` + row.ktp_number : '-' ;
            reportUser["Phone Number"] = row.phone_number ? `'` + row.phone_number  : '-' ;
            reportUser["Email"] = row.email ? row.email : '-' ;
            reportUser["Place of Birth"] = row.place_of_birth ? row.place_of_birth : '-' ;
            reportUser["Date of Birth"] = row.date_of_birth ? row.date_of_birth : '-' ;
            reportUser["Gender"] = row.gender_id ? this.checkGender(row.gender_id) : '-' ;
            reportUser["Religion"] = row.religion_id ? this.checkReligion(row.religion_id) : '-' ;
            reportUser["Marital Status"] = row.master_marital_status ? row.master_marital_status.nameEn : '-' ;
            reportUser["Citizenship"] = row.citizenship ? row.citizenship : '-' ;
            reportUser["NPWP"] = row.npwp_number ? row.npwp_number : '-' ;
            reportUser["Position"] = row.job_position;
            reportUser["Name Group"] = row.group_alias;
            reportUser["Role"] = this.getRole(row.role);
            reportUser["Status User"] = row.status == 1 ? "Active" : "Inactive";
            reportUser["Register"] = this.statusRegisterAlternative(row.id);
            reportUser["Join Date"] = this.formatTime(row.created_at);
            reportUser["Resignation Date"] = row.resignation_date ? row.resignation_date : '-' ;
            reportUser["Identity Card Address"] = row.user_addresses && row.user_addresses[0] ? row.user_addresses[0].address : '-' ;
            reportUser["Home Address"] = row.user_addresses && row.user_addresses[1] ? row.user_addresses[1].address : '-' ;
            this.users_report.push(reportUser);
          }
        });
      },
      checkReligion(religionId){
        const ind = this.religionList.findIndex(e => {
              return e.id == religionId
            })
        return this.religionList[ind].nameEn
      },
      checkGender(gender){
        const ind = this.genderList.findIndex(e => {
              return e.id == gender
            })
        return this.genderList[ind].nameEn
      },
      async searchEmployee() {
        this.loadingSearch = false;
        const userId = this.$store.getters.user.id
        const result = await this.$store.dispatch('getEmployeeByCompanyId', {
          userId
        })
        this.loadingSearch = false
        return result
      },
      async fetchUsersDownload() {
        this.firstLoading = false;
        const userId = this.$store.getters.user.id
        this.loadingDownload = true
        const result = await this.$store.dispatch('getEmployeeByCompanyId', {
          userId
        })
        this.mappingDataReport(result.all)
        this.loadingDownload = false
      },
      async fetchUserDetails(user_id, dialog = "") {
        const result = await this.$store.dispatch('getEmployeeDetail', {
          user_id
        })
        this.detailZone = result.group.zones;
        this.user_full_detail = result;
        this.detailSchedule = result.schedule_users[0];
        this.scheduleItem.userId = this.scheduleItem.id;
        this.scheduleItem = Object.assign(
          this.scheduleItem,
          this.detailSchedule
        );
        this.loadingDetails = false;
        if (dialog == "schedule") {
          this.dialogSchedule = true;
        } else {
          this.detailsDialog = true;
        }
      },
      async fetchGroupDetails() {
        const result = await this.$store.dispatch('getGroupByCompany', {
          companyId: this.company_id
        })
        this.groupList = result
        this.groupListSelection = [].concat(result);
        this.groupList.unshift({
          alias: this.$i18n.t('all'),
          id: null
        });
      },
      async addUser(item) {
        this.saveLoading = true
        const body = {
          id: item.id,
          full_name: item.full_name,
          email: item.email,
          job_position: item.job_position,
          groupId: item.groupId,
          income: item.income ? item.income : 0,
          role: item.role,
          employee_code: item.employee_code,
          status: 1,
          is_join_company: true,
        }
        const result = await this.$store.dispatch('saveEmployeeData', body)
        this.saveLoading = false
        if (result) {
          this.addDialog = false;
          this.showMessage('success', 'Data save successfuly')
          this.fetchUsers();
          this.fetchGroupDetails();
        }
      },
      refreshData() {
        this.addDialog = false
        this.fetchUsers();
        this.fetchGroupDetails();
      },
      async deleteUserAuth(userId) {
        await this.$store.dispatch('deleteEmployeeAuth', {
          userId
        })
      },
      async deleteUser(data) {
        this.loading = true
        const result = await this.$store.dispatch('deleteEmployee', {
          id: data.id
        })
    
        if (result) {
          await this.$store.dispatch('getGlobalConfig', {
            userId: this.$store.state.user.id
          })
          this.loading = false
          this.deleteDialog = false;
          this.showMessage('success', this.$i18n.t('alert_delete'))
          // if (this.statusRegister(data.is_registered) == "Registered") {
          //   await this.deleteUserAuth(data.id);
          // }
          this.loading = false
          this.fetchUsers();
        }
      },
      async getReligion() {
      this.loading = true
      this.religionList = await this.$store.dispatch('getReligion')
      this.loading = false
    },
    },
    mounted() {
      let tmp = this
      if (!this.gcFolderEnabled) {
        tmp.menuDialog = tmp.menuDialog.filter(
          (val) => val.name != 'Folder'
        );
      }
    },
    beforeMount() {
      this.fetchUsers();
      this.fetchGroupDetails();
      this.role.map((item) => {
        this.roles.push(item);
      });
    },
    watch: {
      dialog() {
        this.changeNUserStatus(this.editedItem.status);
        this.changeUserRole(this.editedItem.role);
      },
      addDialog() {
        if (this.$refs.addForm) {
          this.$refs.addForm.reset();
        }
      },
      async searchInput() {
        if (this.loadingSearch) return
        if (this.dataSearch.length > 0) return
        const data = await this.searchEmployee()
        this.dataSearch = data.all
      }
    },
  };
</script>
<style scoped>
  .mouseover {
    position: absolute;
    bottom: 470px;
    left: 63px;
    height: 23px;
  }

  .break-word {
    word-break: break-all;
    white-space: normal;
  }

  .line-height {
    height: 40px;
    overflow: hidden;
  }

  .mw-250 {
    max-width: 250px;
    min-width: 10px;
  }

  .middle {
    vertical-align: middle;
  }

  .justify {
    text-align: justify;
  }

  .h-90 {
    min-height: 90vh;
  }

  .h-80 {
    min-height: 80vh;
  }

  .v-list-item__title {
    color: #fff;
  }

  :not(.v-list-group__header).v-list-item--active .v-list-item__title {
    color: #033a6d !important;
    caret-color: #033a6d !important;
    font-weight: 700;
  }

  .v-list-item--link:before {
    background-color: #a9cefc !important;
  }

  .f-16 {
    font-size: 16px !important;
    /* font-weight: 700 !important; */
    letter-spacing: 1.5px !important;
  }

  .f-13 {
    font-size: 13px !important;
  }

  .cursor {
    cursor: pointer;
  }

  .text-primary {
    color: #033a6d !important;
  }

  .text-danger {
    color: #FF5252;
  }

  .text-blue {
    color: #1876D1;
  }

  .v-list-item__mask {
    background: #b3d4fc !important;
  }
</style>
<style>
  .form-no-scroll {
    overflow-y: hidden !important;
  }

  .form-scroll {
    overflow-y: auto !important;
    min-height: 75vh !important;
  }

  .sae-img-border.with-bg {
    background-color: white;
  }

  .sae-img-border {
    border: solid white 3px;
    -webkit-box-shadow: 0 3px 3px -1px rgb(0 0 0 / 20%),
      0 3px 5px 0 rgb(0 0 0 / 14%), 0 1px 6px 0 rgb(0 0 0 / 12%);
    box-shadow: 0 3px 3px -1px rgb(0 0 0 / 20%), 0 3px 5px 0 rgb(0 0 0 / 14%),
      0 1px 6px 0 rgb(0 0 0 / 12%);
  }

  .sae-required label::after {
    content: ' *';
    color: red;
  }
</style>